import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import _ from 'lodash';
import moment from 'moment';
import navigationModule from './modules/navigation';
import uuid from 'uuid';
import url from '../../config/root-url';

Vue.use(Vuex);

const logActivity = process.env.NODE_ENV === `development` || true;

const log = (logContent) => {
  if (logActivity) {
    let logTextContent = logContent;
    let logObjContent = null;
    if (typeof logContent === `object` && logContent !== null) {
      logObjContent = logContent;
      logTextContent = ``;
    }
    // console.log(logContent, typeof logContent);
    const logItem = `${moment().format(`DD/MM/YY HH:mm`)} - ${logTextContent}`;
    let dbLogItem = logItem;
    const consoleParams = [logItem];
    if (logObjContent !== null) {
      // dbLogItem = [logItem, logObjContent];
      dbLogItem += `[Object object]`;
      consoleParams.push(logObjContent);
    }
    const dbLogs = JSON.parse(localStorage.getItem(`weview_logs`) || `[]`);
    dbLogs.push(dbLogItem)
    localStorage.setItem(`weview_logs`, JSON.stringify(dbLogs));
    console.log(...consoleParams);
  }
};

export default new Vuex.Store({
  modules : {
    navigation : navigationModule,
  },
  state: {
    token                  : null,
    tabletId               : null,
    online                 : false, // tablet is online ?
    authenticated           : null,
    api                    : null, // axios instance to query API
    weviewObject           : null, // all data from weview (managers, surveysStarts, participants...)
    currentParticipant     : null, // used in answer screen
    currentSurvey          : null, // ''
    currentManager         : null,
    currentSurveyStart     : null,
    stagedAnswers          : [], // answers to submit while online
    lastConnectionDate      : null,
    lastRemoteUpdate       : moment(0), // date of last update from the server, used to check if we should update
    lastLocalUpdate        : moment(0), // date of last update successfuly received from the server
    isUpdating             : false,
    dataExpired            : false, // if date is expired, lock tablet until is updated
    lastServiceWorkerCheck : moment(),
    currentQuestion    : null,
  },
  mutations: {
    SET_TOKEN (state, token) {
      state.token = token;
      localStorage.setItem(`weview_token`, token);
    },
    SET_ID_TABLET (state, id) {
      state.tabletId = id;
      localStorage.setItem(`weview_tablet_id`, id);
    },
    SET_ONLINE (state, online) {
      state.online = online;
    },
    SET_AUTHENTICATED (state, authenticated) {
      state.authenticated = authenticated;
    },
    SET_IS_UPDATING (state, updating) {
      state.isUpdating = updating;
    },
    LOAD_TOKEN (state) {
      state.token = localStorage.getItem(`weview_token`);
    },
    LOAD_TABLET_ID (state) {
      state.tabletId = localStorage.getItem(`weview_tablet_id`);
    },
    LOAD_WEVIEW_OBJECT (state) {
      state.weviewObject = JSON.parse(localStorage.getItem(`weview_object`));
    },
    LOAD_STAGED_ANSWERS (state) {
      const textData = localStorage.getItem(`weview_staged_answers`);
      if (textData) {
        state.stagedAnswers = JSON.parse(textData);
      }
    },
    FORGE_API_INSTANCE (state) {
      state.api = axios.create({
        headers: { 'X-Tablet-Token': state.token },
      });
    },
    SET_WEVIEW_OBJECT (state, weviewObject) {
      state.weviewObject = weviewObject;
      localStorage.setItem(`weview_object`, JSON.stringify(state.weviewObject));
    },
    SAVE_WEVIEW_OBJECT (state) {
      localStorage.setItem(`weview_object`, JSON.stringify(state.weviewObject));
    },
    SET_CURRENT_PARTICIPANT (state, participant) {
      log(`setting current particpant`, participant);
      state.currentParticipant = _.cloneDeep(participant);
    },
    SET_CURRENT_SURVEY (state, survey) {
      state.currentSurvey = _.cloneDeep(survey);
      if (survey) {
        let i = 0;
        state.currentSurvey.questions.forEach(q => q.index = i++);
      }
    },
    SET_CURRENT_MANAGER (state, manager) {
      state.currentManager = manager;
    },
    SET_CURRENT_SURVEYSTART (state, surveyStart) {
      state.currentSurveyStart = surveyStart;
    },
    SAVE_CURRENT_ANSWERS (state) {
      // participant has answered all question, saving them...
      // state.currentParticipant.hasAnswered = true; // doesnt work because currentParticipant is a copy
      if (state.currentParticipant.isAdditionnal) {
        const additionnalParticipant         = _.cloneDeep(state.currentParticipant);
        additionnalParticipant.hasAnswered   = true;
        additionnalParticipant.isAdditionnal = false;
        additionnalParticipant.employee      = null;
        state.navigation.currentSurveyStart.participants.push(additionnalParticipant);
      } else {
        const participant = state.currentSurveyStart.participants.find(p => p.id === state.currentParticipant.id);
        participant.hasAnswered = true;
      }
      // stage :
      // (adding id to use when sending answers)
      const answersItem = { participant: _.cloneDeep(state.currentParticipant), survey: state.currentSurvey, _id: uuid.v4() };
      const historyAnswers = JSON.parse(localStorage.getItem(`weview_history_answers`) || `[]`);
      state.stagedAnswers.push(answersItem);
      historyAnswers.push(answersItem);
      // save :
      localStorage.setItem(`weview_staged_answers`, JSON.stringify(state.stagedAnswers));
      localStorage.setItem(`weview_history_answers`, JSON.stringify(historyAnswers));
      localStorage.setItem(`weview_object`, JSON.stringify(state.weviewObject));

      // reset current:
      state.currentParticipant = null;
      state.currentSurvey = null;
    },
    CLEAR_STAGED_DATA (state, participantTabletIds) {
      // unstaging sent answers :
      log(`unstaging sent answers...`);
      participantTabletIds.forEach(participantTabletId => {
        const index = state.stagedAnswers.findIndex(sa => sa._id === participantTabletId);// _id set in SAVE_CURRENY_ANSWERS
        if (index > -1) {
          state.stagedAnswers.splice(index, 1);// actually unstaging
        }
      });
      log(`unstaged answers (${state.stagedAnswers.length} remaining)`);
      // state.stagedAnswers = [];
      localStorage.setItem(`weview_staged_answers`, JSON.stringify(state.stagedAnswers));
    },
    RESET_CURRENTS (state) {
      state.currentSurvey      = null;
      state.currentParticipant = null;
      state.currentManager     = null;
      state.currentSurveyStart = null;
    },
    SAVE_LAST_CONNECTION_DATE (state) {
      state.lastConnectionDate = moment();
    },
    SAVE_REMOTE_UPDATE (state, update) {
      state.lastRemoteUpdate = moment(update);
    },
    SAVE_LOCAL_UPDATE (state, update) {
      state.lastLocalUpdate = moment(update);
    },
    SET_UPDATE_DATES_UPDATED (state) {
      state.lastLocalUpdate = state.lastRemoteUpdate.clone();
    },
    CHECK_EXPIRATION (state) {
      log(`checking expiration date...`);
      if (state.lastConnectionDate && state.lastConnectionDate.clone().add(3, `day`).isBefore(moment())) {
        state.dataExpired = true;
        log(`data is too old, locking tablet...`);
      } else {
        state.dataExpired = false;
        log(`data is viable`);
      }
    },
    SAVE_SERVICEWORKER_CHECK_DATE (state) {
      state.lastServiceWorkerCheck = moment();
    },
    UPDATE_ALL_DELAY (state, timeout) {
      state.updateAllTimeout = timeout;
    },
    CANCEL_UPDATE_ALL_DELAY (state) {
      clearTimeout(state.updateAllTimeout);
    },
    SET_CURRENT_QUESTION (state, question) {
      state.currentQuestion = question;
    },
    SET_ADDITIONAL_ANSWER (state, newAnswer) {
      state.currentQuestion.additionalAnswer = newAnswer;
    },
  },
  actions: {
    updateServiceWorker ({ commit, state }, force = false) { // eslint-disable-line
      log(`update service worker ?`);
      const shouldUpdate = force || state.lastServiceWorkerCheck.clone().add(30, `minutes`).isBefore(moment());
      if (`serviceWorker` in navigator && process.env.NODE_ENV === `production` && shouldUpdate) {
        log(`serviceworker update needed`);
        return navigator.serviceWorker.getRegistration(`${url}/`)
        .then(reg => {
          log(reg);
          if (!reg) {
            log(`enable to get service worker registration`);
            return null;
          }

          log(`checking for serviceworker update.....`);
          commit(`SAVE_SERVICEWORKER_CHECK_DATE`);
          return reg.update();
        });
      }

      log(`no need to update serviceworker, last check too recent`);
      return null;
    },
    resetTablet ({ dispatch }) {
      log(`Reseting tablet ...`);
      localStorage.removeItem(`weview_token`);
      localStorage.removeItem(`weview_tablet_id`);
      localStorage.removeItem(`weview_staged_answers`);
      localStorage.removeItem(`weview_object`);
      dispatch(`init`)
      .then(() => log(`reset process finished`));
    },
    connect ({ commit, dispatch }, code) {
      log(`connecting... ${code}`);
      return axios.post(`/api/tablets/connect`, { connectionCode: code })
      .then(res => {
        log(`connected successfuly`);
        log(res);
        localStorage.removeItem(`weview_token`);
        localStorage.removeItem(`weview_tablet_id`);
        localStorage.removeItem(`weview_staged_answers`);
        localStorage.removeItem(`weview_object`);
        commit(`SET_TOKEN`, res.data.token);
        commit(`SET_ID_TABLET`, res.data.id);
        dispatch(`init`);
      })
      .catch(err => {
        log(`erreur de connection`);
        log(err);
      });
    },
    sendDiag ({ state }) {
      const weviewObject = JSON.parse(localStorage.getItem(`weview_object`) || `{}`);
      if (weviewObject.managers && weviewObject.managers.length) {
        weviewObject.managers = weviewObject.managers.map(manager => {
          const surveyStarts = manager.surveyStarts.map(surveyStart => ({
            ...surveyStart,
            participants : `property deleted for logs weight`,
          }));

          return {
            ...manager,
            surveyStarts,
          };
        });
      }
      const diagContent = JSON.stringify({
        weview_token : localStorage.getItem(`weview_token`) || ``,
        weview_object : weviewObject,
        weview_tablet_id : localStorage.getItem(`weview_tablet_id`) || ``,
        weview_staged_answers : JSON.parse(localStorage.getItem(`weview_staged_answers`) || `[]`),
        weview_history_answers : JSON.parse(localStorage.getItem(`weview_history_answers`) || `[]`),
        weview_logs : JSON.parse(localStorage.getItem(`weview_logs`) || `[]`),
      });
      return state.api.post(`/api/tablets/diagnostic-report`, { content : diagContent });
    },
    // test connection and tell us if we can update
    testConnection ({ commit, state }) {
      if (!state.token || !state.tabletId) {
        log(`No token or tablet ID`);
        return Promise.reject();
      }
      log(`pinging server...`);

      return state.api.get(`/api/tablets/${state.tabletId}/check`)
      .then(res => {
        log(`connected, update`, res.data.update);
        commit(`SAVE_REMOTE_UPDATE`, res.data.update);
        commit(`SET_AUTHENTICATED`, true);
        commit(`SET_ONLINE`, true);
        return true;
      })
      .catch(err => {
        log(err);
        if (err.response && (err.response.status === 400 || err.response.status === 401)) {
          log(`Server error, wrong id or token ?`);
          //  token + id rejected
          commit(`SET_AUTHENTICATED`, false);
          commit(`SET_ONLINE`, true);
          return false;
        }

        log(`app is offline`);
        commit(`SET_ONLINE`, false);
        return false;
      });
    },
    saveCurrentAnswers ({ commit, dispatch }) {
      commit(`SAVE_CURRENT_ANSWERS`);
      commit(`RESET_CURRENTS`);

      return dispatch(`updateAll`);
    },
    init ({ commit, dispatch }) {
      log(`initializing store...`);
      commit(`LOAD_TOKEN`);
      commit(`LOAD_TABLET_ID`);
      commit(`LOAD_WEVIEW_OBJECT`);
      commit(`LOAD_STAGED_ANSWERS`);
      commit(`SET_CURRENT_SURVEY`, null);
      commit(`SET_CURRENT_PARTICIPANT`, null);

      commit(`FORGE_API_INSTANCE`);

      return dispatch(`updateAll`, true);
    },
    changeOnlineStatus ({ commit, dispatch }, online) {
      log(`Online status has changed to:`);
      log(online);
      if (online) {
        log(`Internet connection probably acquired, trigger update....`);
        dispatch(`triggerUpdate`);
      }
      commit(`SET_ONLINE`, online);
    },
    triggerUpdate ({ dispatch, commit }) {
      log(`update triggered`);

      commit(`CHECK_EXPIRATION`);

      return dispatch(`updateAll`);
    },
    updateAll ({ dispatch, commit, state }, force = false) {
      if (state.isUpdating) return null;
      commit(`CANCEL_UPDATE_ALL_DELAY`);
      commit(`SET_IS_UPDATING`, true);

      return dispatch(`testConnection`)
      .then(ok => {
        if (!ok) {
          commit(`SET_IS_UPDATING`, false);
          return Promise.reject(`update process can't be started`);
        }

        return Promise.resolve();
      })
      .then(() => dispatch(`sendAllAnswers`))
      .then(() => commit(`SAVE_LAST_CONNECTION_DATE`))
      .then(() => commit(`CHECK_EXPIRATION`))
      // .then(() => dispatch(`testConnection`))
      .then(() => {
        if (force || state.dataExpired || state.lastRemoteUpdate.isAfter(state.lastLocalUpdate)) {
          log(`update needed${force ? ` (forced)` : ``}`);
          return Promise.resolve();
        }

        return Promise.reject(`no need to update, local and remote date ok`);
      })
      .then(() => dispatch(`updateWeviewObject`))
      .then(() => commit(`SET_UPDATE_DATES_UPDATED`))
      .then(() => commit(`SET_IS_UPDATING`, false))
      .catch(err => {
        log(err);
        commit(`SET_IS_UPDATING`, false);
        commit(`CHECK_EXPIRATION`);
      })
      .then(() => dispatch(`delayUpdateAllIfNeeded`))
      .then(() => dispatch(`updateServiceWorker`, force));
    },
    updateWeviewObject ({ commit, state }) {
      log(`updating weview data from server...`);
      return state.api.get(`/api/tablets/${state.tabletId}/config`)
      .then(response => {
        log(response.data);
        commit(`SET_WEVIEW_OBJECT`, response.data);
        log(`data updated`);
      })
      .catch(err => {
        log(err);
      });
    },
    delayUpdateAllIfNeeded ({ commit, state, dispatch }) {
      if (state.stagedAnswers.length || state.dataExpired) {
        commit(`UPDATE_ALL_DELAY`,
          setTimeout(() => dispatch(`updateAll`, true), 5000)
        );
      }
    },
    sendAllAnswers ({ commit, state, dispatch }) {
      log(`sending staged answers...`);
      if (state.stagedAnswers.length === 0) {
        log(`no answer to send`);
        return Promise.resolve();
      }

      const sendingAnswers = _.cloneDeep(state.stagedAnswers).map(answers => {
        _.filter(answers.survey.questions, question => Boolean(question.questionnaire)).forEach(question => {
          if (_.isArray(question.additionalAnswer)) {
            question.additionalAnswer = question.additionalAnswer.join(`, `);
          }
        });
        return answers;
      });

      return state.api.post(`/api/tablets/${state.tabletId}/answers`, sendingAnswers)
      .then(res => {
        log(`answers sent successfuly`);
        log(res);
        if (res.status === 200 && res.data.success) {
          commit(`CLEAR_STAGED_DATA`, res.data.participantTabletIds);
          return dispatch(`testConnection`);
        }
      })
      .catch(e => {
        log(`answers not sent`);
        log(e);
      });
    },
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js